define('OutSystems/ReactView/BaseView',["require", "exports", "tslib", "OutSystems/ClientRuntime/ApplicationInfo", "OutSystems/ClientRuntime/ErrorHandling", "OutSystems/ClientRuntime/EventDispatcher", "OutSystems/ClientRuntime/Flow", "OutSystems/ClientRuntime/Injector", "OutSystems/ClientRuntime/Injector/KnownServices", "OutSystems/ClientRuntime/Logger", "OutSystems/ClientRuntime/Navigation", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ClientRuntime/Public", "OutSystems/ClientRuntime/ScreenStateCache", "OutSystems/ClientRuntime/ScriptsManager", "OutSystems/ClientRuntime/Validation", "OutSystems/ClientRuntime/WidgetNaming", "prop-types", "react", "react-dom", "./AnimatedGroup", "./CSSHelper", "./ErrorBoundary", "./HtmlTags", "./ScrollExtensions"], function (require, exports, tslib_1, ApplicationInfo, ErrorHandling, EventDispatcher_1, Flow, Injector_1, KnownServices_1, Logger, Navigation, ObjectExtensions, Public_1, ScreenStateCache_1, ScriptsManager, Validation_1, WidgetNaming_1, PropTypes, React, ReactDOM, AnimatedGroup_1, CSSHelper, ErrorBoundary_1, HtmlTags_1, ScrollExtensions) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.executeAfterPaint = exports.BaseWebScreen = exports.BaseWebBlock = exports.View = exports.ViewComponent = exports.SCREEN_UUID = void 0;
    exports.SCREEN_UUID = "_screen";
    var ViewComponent = (function (_super) {
        tslib_1.__extends(ViewComponent, _super);
        function ViewComponent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.originalNavigationKey = "";
            return _this;
        }
        ViewComponent.prototype.componentDidMount = function () {
            this.injectId();
            var screenStateCache = this.getScreenStateCache();
            this.originalNavigationKey = screenStateCache.navigationKey;
            if (screenStateCache.shouldLoad) {
                var componentStateCache = screenStateCache.state.components[this.getComponentKey()];
                if (componentStateCache && !ObjectExtensions.isEmptyObject(componentStateCache.customProperties)) {
                    this.loadCustomStateProperties(componentStateCache.customProperties);
                }
            }
        };
        ViewComponent.prototype.componentDidUpdate = function () {
            this.injectId();
        };
        ViewComponent.prototype.componentWillUnmount = function () {
            var screenStateCache = this.getScreenStateCache();
            if (screenStateCache.shouldSave) {
                var state = this.serializeState();
                var customProperties = this.serializeCustomStateProperties();
                if (!ObjectExtensions.isEmptyObject(state) || !ObjectExtensions.isEmptyObject(customProperties)) {
                    ScreenStateCache_1.ScreenStateCache.save(this.originalNavigationKey, this.getComponentKey(), state, customProperties);
                }
            }
        };
        ViewComponent.prototype.serializeState = function () {
            return this.state;
        };
        ViewComponent.prototype.serializeCustomStateProperties = function () {
            return null;
        };
        ViewComponent.prototype.loadCustomStateProperties = function (customProperties) { };
        ViewComponent.prototype.getComponentKey = function () {
            var idProperties = this.idServiceProperties;
            var idService = idProperties.service;
            return idService.getId(idProperties.name || idProperties.uuid);
        };
        Object.defineProperty(ViewComponent.prototype, "idServiceProperties", {
            get: function () {
                return this.props._idProps;
            },
            enumerable: false,
            configurable: true
        });
        ViewComponent.prototype.injectId = function () {
            var id = this.getId();
            if (id !== "") {
                var node = this.getHTMLNode();
                if (node && !node.hasAttribute("id")) {
                    node.setAttribute("id", id);
                }
            }
        };
        ViewComponent.prototype.getId = function () {
            var idProperties = this.idServiceProperties;
            var idService = idProperties.service;
            return idService.getId(this.getName(idProperties)) || "";
        };
        ViewComponent.prototype.getName = function (idProperties) {
            return idProperties.name;
        };
        ViewComponent.prototype.getScreenStateCache = function () {
            var context = this.context;
            return context.getScreenStateCache
                ? context.getScreenStateCache()
                : { navigationKey: "", shouldLoad: false, shouldSave: false, state: null };
        };
        ViewComponent.prototype.getSiblingWidgetId = function (sibilingWidgetName) {
            var idServiceProps = this.idServiceProperties;
            return idServiceProps.service.getId(sibilingWidgetName);
        };
        ViewComponent.prototype.findDOMNode = function (element) {
            var result = ReactDOM.findDOMNode(element);
            return result;
        };
        ViewComponent.contextTypes = {
            getScreenStateCache: PropTypes.func,
        };
        return ViewComponent;
    }(React.Component));
    exports.ViewComponent = ViewComponent;
    var View = (function (_super) {
        tslib_1.__extends(View, _super);
        function View(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.onError = function (error) {
                if (View.isLoopError(error)) {
                    View.handleError(View.createRenderLoopError(_this.viewName));
                }
                else {
                    _this.exception = error;
                    _this.controllerInstance.handleError(_this.exception);
                }
            };
            var newState = { model: props.model };
            if (!newState.model) {
                var activeScreenController = _this.controllerFactory.activeScreenController;
                var activeScreenModelContext = activeScreenController
                    ? activeScreenController.modelContext
                    : undefined;
                var currentViewModelContext = {
                    viewName: _this.viewName,
                    navigatedFromHistory: activeScreenModelContext ? activeScreenModelContext.navigatedFromHistory : false,
                    viewWasRestoredFromCache: false,
                };
                newState.model = _this.modelFactory.create(currentViewModelContext);
            }
            _this.state = newState;
            _this.setInputs(props, true);
            _this.controllerInstance = props.controller
                ? props.controller
                : _this.controllerFactory.create(_this.state.model, _this.createIdService());
            _this.navigationEventListenerId = EventDispatcher_1.EventDispatcher.listenOnce(EventDispatcher_1.EventType.NavigationStart, function () {
                return _this.onNavigationStart();
            });
            if (!_this.hasScreenRendered()) {
                _this.transitionEventStartListenerId = EventDispatcher_1.EventDispatcher.listenOnce(EventDispatcher_1.EventType.TransitionStart, function () {
                    return _this.onTransitionStart();
                });
            }
            return _this;
        }
        View.ifWidget = function (condition, animate, thisArg, trueBranch, falseBranch) {
            var branchTrue;
            var branchFalse;
            if (condition) {
                branchTrue = trueBranch.call(thisArg);
            }
            else {
                branchFalse = falseBranch.call(thisArg);
            }
            var disabledAnimation = true;
            if (!disabledAnimation && animate) {
                var obj_1 = {};
                obj_1["true-branch"] = branchTrue;
                obj_1["false-branch"] = branchFalse;
                if (!!branchTrue && (branchTrue.length > 1 || typeof branchTrue[0] === "string")) {
                    obj_1["true-branch"] = React.createElement(HtmlTags_1.HtmlTags.span, {}, branchTrue);
                }
                if (!!branchFalse && (branchFalse.length > 1 || typeof branchFalse[0] === "string")) {
                    obj_1["false-branch"] = React.createElement(HtmlTags_1.HtmlTags.span, {}, branchFalse);
                }
                return React.createElement(AnimatedGroup_1.AnimatedGroup, {}, Object.keys(obj_1).map(function (key) { return React.createElement(React.Fragment, { key: key }, obj_1[key]); }));
            }
            else {
                return React.createElement(React.Fragment, null, branchTrue ? React.createElement.apply(React, tslib_1.__spreadArray([React.Fragment, null], branchTrue, false)) : null, branchFalse ? React.createElement.apply(React, tslib_1.__spreadArray([React.Fragment, null], branchFalse, false)) : null);
            }
        };
        View.textWidget = function (text) {
            var components = [];
            if (text.length !== 0) {
                var textLines = text.split("\n");
                for (var _i = 0, _a = textLines.slice(0, textLines.length - 1); _i < _a.length; _i++) {
                    var textLine = _a[_i];
                    if (textLine.length !== 0) {
                        components.push(textLine);
                    }
                    components.push(React.createElement("br"));
                }
                var remainingText = textLines[textLines.length - 1];
                if (remainingText.length !== 0) {
                    components.push(remainingText);
                }
            }
            return components;
        };
        View.getTranslation = function (key, defaultValue) {
            var translationsService = Injector_1.default.resolve(KnownServices_1.ServiceNames.TranslationsService);
            return translationsService ? translationsService.getMessage(key, defaultValue) : defaultValue;
        };
        View.asPrimitiveValue = function (value) {
            if (value === undefined || value === null) {
                return value;
            }
            return value.valueOf();
        };
        View.prototype.createIdService = function () {
            return new WidgetNaming_1.WidgetIdService(null);
        };
        View.prototype.onNavigationStart = function () {
            this.saveModelStateForCache();
        };
        View.prototype.onTransitionStart = function () {
            var _this = this;
            this.transitionEventStartListenerId = null;
            if (this.pendingModel) {
                executeAfterPaint(function () {
                    if (_this.pendingModel) {
                        _this.onModelChanged(_this.pendingModel);
                    }
                });
            }
        };
        View.prototype.setInputs = function (props, shouldFlush) { };
        View.prototype.subscribeModelChanges = function () {
            var _this = this;
            this.model.subscribeWrites(function (newModel) { return _this.onModelChanged(newModel); });
        };
        View.prototype.savePreviousModelState = function () {
            this.previousModelData = this.model.toImmutableData();
        };
        View.prototype.saveModelStateForCache = function () {
            this.cachedModelData = this.previousModelData;
        };
        View.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
            return this.previousModelData !== nextState.model.toImmutableData();
        };
        View.prototype.componentWillUnmount = function () {
            var _this = this;
            this.model.clearSubscriptions();
            _super.prototype.componentWillUnmount.call(this);
            EventDispatcher_1.EventDispatcher.unregister(this.navigationEventListenerId);
            EventDispatcher_1.EventDispatcher.unregister(this.transitionEventStartListenerId);
            this.onDestroy();
            setTimeout(function () { return _this.controller.dispose(); });
        };
        View.prototype.componentDidMount = function () {
            _super.prototype.componentDidMount.call(this);
            this.onReady();
        };
        View.prototype.componentDidUpdate = function () {
            _super.prototype.componentDidUpdate.call(this);
            this.onRender();
        };
        View.prototype.serializeState = function () {
            var data = this.cachedModelData || this.previousModelData;
            return this.model.sanitize(data);
        };
        View.prototype.UNSAFE_componentWillUpdate = function (nextProps) {
            this.savePreviousModelState();
        };
        View.prototype.onReady = function () {
            this.controller.fireAfterViewReady();
        };
        View.prototype.onRender = function () {
            var _this = this;
            var result = this.controller.fireAfterViewRender();
            if (result) {
                result.catch(function (error) {
                    if (View.isLoopError(error)) {
                        View.handleError(View.createRenderLoopError(_this.viewName, _this.constructor.displayName));
                    }
                });
            }
        };
        View.prototype.onDestroy = function () {
            this.controller.fireAfterViewDestroy();
        };
        View.prototype.hasScreenRendered = function () {
            var context = this.context;
            return !context || !context.hasScreenRendered || context.hasScreenRendered();
        };
        View.prototype.onModelChanged = function (newModel) {
            var _this = this;
            if (this.hasScreenRendered()) {
                this.pendingModel = null;
                this.setState({ model: newModel }, function () {
                    _this.onSetState();
                });
            }
            else {
                this.pendingModel = newModel;
            }
        };
        View.prototype.onSetState = function () { };
        Object.defineProperty(View.prototype, "model", {
            get: function () {
                return this.state.model;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(View.prototype, "controller", {
            get: function () {
                return this.controllerInstance;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(View.prototype, "idService", {
            get: function () {
                return this.controller.idService;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(View.prototype, "viewName", {
            get: function () {
                return this.constructor.displayName;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(View.prototype, "title", {
            get: function () {
                throw new Error("@abstract");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(View.prototype, "modelFactory", {
            get: function () {
                throw new Error("@abstract");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(View.prototype, "controllerFactory", {
            get: function () {
                throw new Error("@abstract");
            },
            enumerable: false,
            configurable: true
        });
        View.getCssDependencies = function () {
            return [];
        };
        View.getJsDependencies = function () {
            return [];
        };
        View.getBlocks = function () {
            return [];
        };
        Object.defineProperty(View.prototype, "widgetsRecordProvider", {
            get: function () {
                return this.model;
            },
            enumerable: false,
            configurable: true
        });
        View.isLoopError = function (error) {
            return /Maximum update depth exceeded/gi.test(error === null || error === void 0 ? void 0 : error.message);
        };
        View.createRenderLoopError = function (viewName, blockName) {
            return new Error("Render loop avoided. " +
                "This is likely due to variables of ".concat(!!blockName ? "block '".concat(blockName, "' on ") : "", "screen '").concat(viewName, "' being changed inside its 'On Render' event handler. ") +
                "Avoid changing variables inside 'On Render' event handlers.");
        };
        View.prototype.render = function () {
            this.exception = undefined;
            return React.createElement(ErrorBoundary_1.default, { onError: this.onError }, this.internalRender());
        };
        View.prototype.internalRender = function () {
            throw new Error("@abstract");
        };
        View.prototype.validateWidget = function (widgetId) {
            this.controller.validationService.validate(widgetId);
        };
        View.handleError = function (error) {
            ErrorHandling.handleError(error);
        };
        View.contextTypes = ObjectExtensions.assign({
            hasScreenRendered: PropTypes.func,
            locale: PropTypes.string,
        }, ViewComponent.contextTypes);
        return View;
    }(ViewComponent));
    exports.View = View;
    var BaseWebBlock = (function (_super) {
        tslib_1.__extends(BaseWebBlock, _super);
        function BaseWebBlock(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.isValid = true;
            _this.generationNode = context.ancestorGenerationNode.addChild();
            if (props.events) {
                var _loop_1 = function (eventName) {
                    var actionName = eventName;
                    if (actionName.charAt(0) === "_") {
                        actionName = actionName.substring(1);
                    }
                    var event_1 = props.events[eventName];
                    this_1.controller.registerClientAction(actionName, function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return Flow.executeSequence(function () { return event_1.apply(void 0, args); });
                    });
                };
                var this_1 = this;
                for (var _i = 0, _a = Object.keys(props.events); _i < _a.length; _i++) {
                    var eventName = _a[_i];
                    _loop_1(eventName);
                }
            }
            var screenStateCache = _this.getScreenStateCache();
            if (screenStateCache.shouldLoad) {
                var stateCache = screenStateCache.state.components[_this.getComponentKey()];
                if (stateCache && !ObjectExtensions.isEmptyObject(stateCache.state)) {
                    _this.state.model.fromImmutableData(stateCache.state);
                    _this.state.model.context.viewWasRestoredFromCache = true;
                    _this.setInputs(_this.props, true);
                }
            }
            if (_this.parentValidationService) {
                _this.parentValidationService.register(_this);
            }
            _this.controller.fireInitialize();
            _this.subscribeModelChanges();
            _this.savePreviousModelState();
            return _this;
        }
        BaseWebBlock.prototype.getChildContext = function () {
            return {
                ancestorGenerationNode: this.generationNode,
                locale: this.context.locale,
            };
        };
        BaseWebBlock.prototype.createIdService = function () {
            var idServiceProps = this.idServiceProperties;
            return new WidgetNaming_1.WidgetIdService(idServiceProps.service, idServiceProps.alias, WidgetNaming_1.NamespaceKind.Block);
        };
        BaseWebBlock.prototype.setInputs = function (props, shouldFlush) {
            if (props.inputs && Object.keys(props.inputs).length > 0) {
                this.model.setInputs(props.inputs);
                if (shouldFlush) {
                    this.model.flush();
                }
            }
        };
        BaseWebBlock.prototype.getName = function (idProperties) {
            return _super.prototype.getName.call(this, idProperties) || "$b" + idProperties.alias;
        };
        BaseWebBlock.prototype.UNSAFE_componentWillUpdate = function (nextProps) {
            var _this = this;
            if (!ObjectExtensions.shallowEquals(this.props.inputs, nextProps.inputs)) {
                Logger.trace(this, function () { return "Inputs of '".concat(_this.getId(), "' changed"); });
                this.setInputs(nextProps, false);
                try {
                    this.controller.fireAfterInputsChanged();
                }
                finally {
                    Logger.trace(this, function () { return "InputsChanged event fired on '" + _this.getId() + "'"; });
                }
            }
            _super.prototype.UNSAFE_componentWillUpdate.call(this, nextProps);
        };
        BaseWebBlock.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
            if (_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState, nextContext) ||
                !ObjectExtensions.shallowEquals(this.props.inputs, nextProps.inputs)) {
                return true;
            }
            if (!nextProps._dependencies && nextProps.placeholders) {
                return true;
            }
            if (this.generationNode && !nextContext.isGenerationUpToDate(this.generationNode.generation)) {
                return true;
            }
            return !ObjectExtensions.arrayShallowEquals(this.props._dependencies, nextProps._dependencies);
        };
        Object.defineProperty(BaseWebBlock.prototype, "viewName", {
            get: function () {
                return this.context.viewName;
            },
            enumerable: false,
            configurable: true
        });
        BaseWebBlock.prototype.getRootNodeProperties = function () {
            return {
                "data-block": this.constructor.displayName,
                ref: BaseWebBlock.ReferenceName,
                className: "OSBlockWidget",
            };
        };
        BaseWebBlock.prototype.onSetState = function () {
            this.context.refreshCurrentGeneration();
        };
        Object.defineProperty(BaseWebBlock.prototype, "parentValidationServiceProperties", {
            get: function () {
                return this.props._validationProps;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseWebBlock.prototype, "validationParentId", {
            get: function () {
                var validationServiceProps = this.parentValidationServiceProperties;
                if (validationServiceProps) {
                    return validationServiceProps.validationParentId;
                }
                return null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseWebBlock.prototype, "parentValidationService", {
            get: function () {
                var validationServiceProps = this.parentValidationServiceProperties;
                if (validationServiceProps) {
                    return validationServiceProps.validationService;
                }
                return null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseWebBlock.prototype, "valid", {
            get: function () {
                return this.isValid;
            },
            set: function (value) {
                this.isValid = value === undefined ? true : value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseWebBlock.prototype, "isValidationAggregator", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseWebBlock.prototype, "isWebBlockInstance", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        BaseWebBlock.prototype.validate = function () {
            return new Validation_1.ValidationResult(this.controller.validationService.validate(""));
        };
        BaseWebBlock.prototype.componentWillUnmount = function () {
            _super.prototype.componentWillUnmount.call(this);
            if (this.parentValidationService) {
                this.parentValidationService.unregister(this.getId());
            }
        };
        BaseWebBlock.prototype.validateWidget = function (widgetId) {
            if (widgetId) {
                _super.prototype.validateWidget.call(this, widgetId);
            }
            else {
                this.parentValidationService.validate(this.validationParentId);
            }
        };
        BaseWebBlock.prototype.getHTMLNode = function () {
            var element = this.refs[BaseWebBlock.ReferenceName];
            if (element) {
                return this.findDOMNode(element) || this.findDOMNode(this);
            }
            else {
                return this.findDOMNode(this);
            }
        };
        BaseWebBlock.ReferenceName = "block-reference";
        BaseWebBlock.contextTypes = ObjectExtensions.assign({
            ancestorGenerationNode: PropTypes.object,
            refreshCurrentGeneration: PropTypes.func,
            isGenerationUpToDate: PropTypes.func,
            viewName: PropTypes.string,
        }, View.contextTypes);
        BaseWebBlock.childContextTypes = {
            ancestorGenerationNode: PropTypes.object,
            locale: PropTypes.string,
        };
        return BaseWebBlock;
    }(View));
    exports.BaseWebBlock = BaseWebBlock;
    var BaseWebScreen = (function (_super) {
        tslib_1.__extends(BaseWebScreen, _super);
        function BaseWebScreen(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.isUnloading = false;
            _this.isLoadingFromHistory = false;
            _this.screenElement = undefined;
            if (!props.controller) {
                _this.controller.fireInitialize();
            }
            _this.subscribeModelChanges();
            _this.savePreviousModelState();
            _this.isLoadingFromHistory = !!props.cachedScreenState;
            return _this;
        }
        BaseWebScreen.prototype.serializeCustomStateProperties = function () {
            return ScrollExtensions.serializeScrollProperties(document.body);
        };
        BaseWebScreen.prototype.loadCustomStateProperties = function (customProperties) {
            ScrollExtensions.loadScrollProperties(document.body, customProperties);
        };
        BaseWebScreen.prototype.getScreenStateCache = function () {
            return {
                navigationKey: this.props.navigationKey,
                shouldSave: this.isUnloading && this.props.shallSaveStateOnLeave,
                shouldLoad: this.isLoadingFromHistory,
                state: this.props.cachedScreenState,
            };
        };
        BaseWebScreen.prototype.getChildContext = function () {
            var _this = this;
            var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
            return {
                ancestorGenerationNode: this.model.widgetsGenerationsTree.root,
                isGenerationUpToDate: function (generation) { return generation <= _this.currentGeneration; },
                refreshCurrentGeneration: function () { return _this.refreshCurrentGeneration(); },
                viewName: this.viewName,
                getScreenStateCache: function () { return _this.getScreenStateCache(); },
                locale: localeService === null || localeService === void 0 ? void 0 : localeService.getCurrentLocale(),
            };
        };
        BaseWebScreen.prototype.getRootNodeProperties = function () {
            return { className: Public_1.View.ActiveScreenCssClass + " screen-container" };
        };
        Object.defineProperty(BaseWebScreen.prototype, "idServiceProperties", {
            get: function () {
                return {
                    service: this.idService,
                    uuid: exports.SCREEN_UUID,
                };
            },
            enumerable: false,
            configurable: true
        });
        BaseWebScreen.prototype.getComponentKey = function () {
            return exports.SCREEN_UUID;
        };
        BaseWebScreen.collectResourcesOrderedByPriority = function (root, resourceAttrAccessor) {
            var seen = {};
            var collectedResources = [];
            var visit = function (view) {
                var children = view.getBlocks();
                for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                    var child = children_1[_i];
                    visit(child);
                }
                for (var _a = 0, _b = resourceAttrAccessor(view); _a < _b.length; _a++) {
                    var resource = _b[_a];
                    if (!seen[resource]) {
                        collectedResources.push(resource);
                        seen[resource] = true;
                    }
                }
            };
            visit(root);
            return collectedResources;
        };
        BaseWebScreen.getJavascriptsOrderedByPriority = function (root) {
            return BaseWebScreen.collectResourcesOrderedByPriority(root, function (child) {
                return child.getJsDependencies();
            });
        };
        BaseWebScreen.getStylesheetsOrderedByPriority = function (root) {
            return BaseWebScreen.collectResourcesOrderedByPriority(root, function (child) {
                return child.getCssDependencies();
            });
        };
        BaseWebScreen.prototype.componentDidMount = function () {
            this.screenElement = this.findDOMNode(this);
            _super.prototype.componentDidMount.call(this);
            if (this.exception) {
                return;
            }
            document.title = this.title;
            BaseWebScreen.updateHTMLLang();
            BaseWebScreen.updateWritingDirectionStyleClass();
            this.refreshCurrentGeneration();
            this.isLoadingFromHistory = false;
            ScreenStateCache_1.ScreenStateCache.clear(this.getScreenStateCache().navigationKey);
        };
        BaseWebScreen.prototype.componentDidUpdate = function () {
            this.screenElement = this.findDOMNode(this);
            _super.prototype.componentDidUpdate.call(this);
            this.refreshCurrentGeneration();
            if (this.exception || !this.controller.isActive()) {
                return;
            }
            document.title = this.title;
            BaseWebScreen.updateHTMLLang();
            BaseWebScreen.updateWritingDirectionStyleClass();
        };
        BaseWebScreen.updateHTMLLang = function () {
            var localeSrv = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
            if (localeSrv) {
                var elems = document.getElementsByTagName("html");
                if (elems.length === 1) {
                    var htmlElem = elems.item(0);
                    htmlElem.setAttribute("lang", localeSrv.getCurrentLocale());
                }
            }
        };
        BaseWebScreen.prototype.componentWillUnmount = function () {
            this.isUnloading = true;
            _super.prototype.componentWillUnmount.call(this);
        };
        BaseWebScreen.prototype.refreshCurrentGeneration = function () {
            this.currentGeneration = this.model.widgetsGenerationsTree.root.generation;
        };
        BaseWebScreen.prototype.injectId = function () {
        };
        BaseWebScreen.prototype.getHTMLNode = function () {
            throw new Error("@abstract");
        };
        BaseWebScreen.prototype.onNavigationStart = function () {
            _super.prototype.onNavigationStart.call(this);
            if (this.screenElement) {
                this.screenElement.classList.remove(Public_1.View.ActiveScreenCssClass);
            }
        };
        BaseWebScreen.loadResources = function (component) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var stylesheetURLs, javascriptURLs, cssPreparation, triggerRemoveStyles;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            stylesheetURLs = BaseWebScreen.getStylesheetsOrderedByPriority(component).map(function (url) {
                                return Navigation.VersionedURL.getVersionedUrl(url);
                            });
                            javascriptURLs = BaseWebScreen.getJavascriptsOrderedByPriority(component).map(function (url) {
                                return Navigation.VersionedURL.getVersionedUrl(url);
                            });
                            cssPreparation = CSSHelper.scheduleCSSPreparation(stylesheetURLs, BaseWebScreen.logError);
                            triggerRemoveStyles = cssPreparation.triggerRemoveStyles;
                            EventDispatcher_1.EventDispatcher.listenOnce(EventDispatcher_1.EventType.TransitionEnd, function (args) {
                                if (args === EventDispatcher_1.TransitionEndResult.Success) {
                                    triggerRemoveStyles();
                                }
                            });
                            return [4, ScriptsManager.scheduleCustomJsLoading(javascriptURLs, BaseWebScreen.logError)];
                        case 1:
                            _a.sent();
                            if (!ApplicationInfo.isWebApplication()) return [3, 3];
                            return [4, cssPreparation.loadStylesPromise];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2];
                    }
                });
            });
        };
        BaseWebScreen.updateWritingDirectionStyleClass = function () {
            var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
            if (localeService) {
                var bodyElem = document.body;
                if (!!bodyElem) {
                    if (localeService.isCurrentLocaleRTL()) {
                        bodyElem.classList.remove("is-ltr");
                        bodyElem.classList.add("is-rtl");
                    }
                    else {
                        bodyElem.classList.remove("is-rtl");
                        bodyElem.classList.add("is-ltr");
                    }
                }
            }
        };
        BaseWebScreen.logError = function (error) {
            Logger.error("BaseWebScreen", error);
        };
        BaseWebScreen.childContextTypes = {
            ancestorGenerationNode: PropTypes.object,
            isGenerationUpToDate: PropTypes.func,
            refreshCurrentGeneration: PropTypes.func,
            viewName: PropTypes.string,
            getScreenStateCache: PropTypes.func,
            locale: PropTypes.string,
        };
        return BaseWebScreen;
    }(View));
    exports.BaseWebScreen = BaseWebScreen;
    function executeAfterPaint(action) {
        requestAnimationFrame(function () { return setTimeout(action, 1); });
    }
    exports.executeAfterPaint = executeAfterPaint;
});
//# sourceMappingURL=BaseView.js.map;
